export default __webpack_public_path__ + "maps-overview-annotation-view-960-68f11a90dd2bc11da0d342015c34da04.png";